<template>
  <div class="elevation-1">
    <v-toolbar flat>
      <v-btn flat to="/billing/dashboard"> Dashboard </v-btn>
      <v-btn flat to="/billing/billing"> Billing </v-btn>
      <v-btn flat to="/billing/contracts"> Contracts </v-btn>
      <v-btn flat to="/billing/customers"> Customers </v-btn>
    </v-toolbar>
    <v-flex xs12>
	  	<router-view></router-view>
	  </v-flex>
  </div>
</template>

<script>

import BillingDashboard from './billing/Dashboard.vue'
import BillingPage from './billing/Billing'
import ContractsPage from './billing/Contracts'
import CustomersPage from './billing/Customers'


export default {
	routes: [
		{
			path: '',
			redirect: 'dashboard'
		},
    {
      path: 'dashboard',
      component: BillingDashboard,
      children: BillingDashboard.routes
    },
  	{
      path: 'billing',
      component: BillingPage,
      children: BillingPage.routes
    },
    {
    	path: 'contracts',
    	component: ContractsPage,
    	children: ContractsPage.routes
    },
    {
    	path: 'customers',
    	component: CustomersPage,
    	children: CustomersPage.routes
    },
   ]
}

</script>
